import { render, staticRenderFns } from "./QuestionGroupReview.vue?vue&type=template&id=5e33ac46&scoped=true&"
import script from "./QuestionGroupReview.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupReview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionGroupReview.vue?vue&type=style&index=0&id=5e33ac46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33ac46",
  null
  
)

export default component.exports